var GarageManagement = function () { return import("~/pages/car-management/garage-management.vue"); };
var InventoryVehicle = function () { return import("~/pages/car-management/inventory-vehicle.vue"); };
var WarehouseManagementApproval = function () { return import("~/pages/car-management/warehouse-management-approval.vue"); };
export default [
    {
        path: "/car-management/garage-management",
        name: "garage-management",
        component: GarageManagement,
        title: "车库管理"
    },
    {
        path: "/car-management/inventory-vehicle",
        name: "inventory-vehicle",
        component: InventoryVehicle,
        title: "库存车辆"
    },
    {
        path: "/car-management/warehouse-management-approval",
        name: "warehouse-management-approval",
        component: WarehouseManagementApproval,
        title: "库管审批"
    }
];
